<template>
    <div :class="{ busy: loading }" v-if="types.count > 1">
        <div class="horizontal-list no-scrollbar hidden-not-touch">
            <CatalogQuickFilter
                v-for="type in types"
                v-show="type.count > 1"
                :key="type.id"
                :is-selected="type.id === selectedTypeId"
                :count="type.count"
                :label="type.name"
                :link="type.url"
                :value="type.id"
                url-param="tipo"
            />
        </div>
        <div class="catalog-quick-filters-list d-flex flex-wrap no-scrollbar hidden-touch">
            <CatalogQuickFilter
                v-for="type in types"
                v-show="type.count > 0"
                :key="type.id"
                :is-selected="type.id === selectedTypeId"
                :count="type.count"
                :label="type.name"
                :link="type.url"
                :value="type.id"
                url-param="tipo"
            />
        </div>
    </div>
</template>

<script>
    import CatalogQuickFilter from './CatalogQuickFilter';
    import { catalogStore } from '../../common/store/catalog-store';

    export default {
        name: 'CatalogQuickFiltersList',

        components: { CatalogQuickFilter },

        data() {
            return {
                storeState: catalogStore.state,
                allowedTypes: [
                    // tipos com ícones
                    1, // Camiseta
                    6, // Poster
                    15, // Capas para Celular
                    17, // Caneca
                    18, // Sketchbook
                    25, // Bolsa
                    31, // Avental
                    33, // Meia
                    43, // Banderia decorativa
                    45, // camisa
                ],
            };
        },

        computed: {
            types() {
                return (this.storeState || {}).filters.types.filter((type) =>
                    this.allowedTypes.includes(type.id)
                );
            },

            selected() {
                return (this.storeState || {}).selected;
            },

            selectedTypeId() {
                // considera id > 500 como null pq são os super tipos hardcoded (veja Router.php)
                return (this.selected || {}).type_id && this.selected.type_id < 500
                    ? this.selected.type_id
                    : null;
            },

            loading() {
                return (this.storeState || {}).loading;
            },
        },
    };
</script>
